import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import MainLayout from './components/Layout/MainLayout';
import Login from './pages/Login';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import GameManagement from './pages/GameManagement';
import GameRoomDetail from './pages/GameRoomDetail';
import Users from './pages/Users';
import UserGames from './pages/UserGames';
import Credit from './pages/Credit';
import Withdraw from './pages/Withdraw';
import Transfers from './pages/Transfers';
import Post from './pages/Post';
import FinancialManagement from './pages/FinancialManagement';
import PlatformSettings from './pages/PlatformSettings';
import Settings from './pages/Settings';
import GameHistory from './pages/GameHistory';
import SpinWins from './pages/SpinWins';
import Reconciliation from './pages/Reconciliation';
import Referrals from './pages/Referrals';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: {
      retry: 0,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<MainLayout />}>
              <Route
                index
                element={<Navigate to="/dashboard" replace />}
              />
              <Route path="dashboard" element={<Dashboard />} />
              <Route
                path="game-management"
                element={<GameManagement />}
              />
              <Route
                path="game-rooms/:id"
                element={<GameRoomDetail />}
              />
              <Route path="/game-history" element={<GameHistory />} />
              <Route path="/spin-wins" element={<SpinWins />} />
              <Route path="users" element={<Users />} />
              <Route path="users/:id/games" element={<UserGames />} />
              <Route path="credit" element={<Credit />} />
              <Route path="withdraw" element={<Withdraw />} />
              <Route path="transfers" element={<Transfers />} />
              <Route path="post" element={<Post />} />
              <Route
                path="financial-management"
                element={<FinancialManagement />}
              />
              <Route
                path="reconciliation"
                element={<Reconciliation />}
              />
              <Route
                path="platform-settings"
                element={<PlatformSettings />}
              />
              <Route path="settings" element={<Settings />} />
              <Route path="referrals" element={<Referrals />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;